module.exports = __webpack_public_path__ + "assets/img/rz2.832e9902.png";